import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
import { Route } from 'vue-router';
import store from '@/store';
import { Toast } from 'vant';

export default [
    /** 战队详情部分 */
    {
        path: '/team/detail/normal/:teamId/:activitySpecialId?',
        alias: '/team/detail/share/:activityId/:teamId/:activitySpecialId?',
        name: ROUTE_NAME.TEAM_DETAIL_NORMAL,
        meta: {
            title: '战队详情',
            popup: 'market',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => import(/* webpackChunkName: "team" */ '@/pages/team/detail/normal.vue'),
    },
    {
        path: '/team/detail/home/:teamId',
        // alias: '/team/detail/share/:activityId/:teamId',
        name: ROUTE_NAME.TEAM_DETAIL_HOME,
        meta: {
            title: '战队详情',
            popup: 'market',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => import(/* webpackChunkName: "team" */ '@/pages/team/detail/home.vue'),
    },
    {
        path: '/team/detail/stat/:activityId/:teamId/:activitySpecialId?',
        name: ROUTE_NAME.TEAM_DETAIL_STAT,
        meta: {
            title: '数据统计',
            popup: 'market',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => import(/* webpackChunkName: "team" */ '@/pages/team/detail/stat.vue'),
    },
    {
        path: '/team/detail/rank/:teamId',
        name: ROUTE_NAME.TEAM_DETAIL_RANK,
        meta: {
            title: '排行榜',
            scrollBehavior: 'top',
        },
        component: () => ({
            component: import(/* webpackChunkName: "team" */ '@/pages/team/detail/rank.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/team/invite_card/:activityId/:teamId?',
        name: ROUTE_NAME.TEAM_INVITE_CARD,
        meta: {
            title: '邀请卡',
            scrollBehavior: 'top',
            needLogin: true,
            needLoginNext: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "team" */ '@/pages/team/inviteCard.vue'),
            loading: Loading,
        }),
    },
    // 根据用户报名信息进行跳转
    {
        path: '/team/invite_card_enter/:activityId/:userId',
        async beforeEnter(to: Route, from: Route, next: any) {
            const {
                activityId,
                userId,
            } = to.params;
            store.commit('startRequest');
            const rdata = await store.dispatch('activity/getUserParticipation', {
                activityId,
                userId,
            });
            store.commit('endRequest');
            // 已经报名
            if (rdata.status === 0) {
                const teamId = rdata.data;
                if (teamId) {
                    // 已经报名
                    next({
                        name: ROUTE_NAME.ACTIVITY_SUBMIT_ORDER,
                        params: {
                            activityId,
                            teamId,
                            type: 'pay',
                        },
                        query: {
                            referrer_id: userId,
                        },
                    });
                } else {
                    next({
                        name: ROUTE_NAME.ACTIVITY,
                        params: {
                            activityId,
                        },
                    });
                }
            } else {
                next(false);
            }
        },
    },
    // 只根据team数据来跳转
    {
        path: '/team/invite_card_enter/:teamId?',
        async beforeEnter(to: Route, from: Route, next: any) {
            const teamId = to.params.teamId;
            if (teamId) {
                if (Number(teamId) < 5) {
                    next(false);
                    return;
                }

                store.commit('startRequest');
                await store.dispatch('activity/getTeamDetail', {
                    teamId,
                });
                store.commit('endRequest');
                const teamDetail = store.state.activity.team.detail[Number(teamId)];
                if (teamDetail) {
                    next({
                        name: ROUTE_NAME.ACTIVITY_SUBMIT_ORDER,
                        params: {
                            activityId: teamDetail.activity_id,
                            teamId,
                            type: 'pay',
                        },
                    });
                    return;
                }
            }
            // 没有teamId的时候，跳转到当前正在进行中的活动
            next({
                name: ROUTE_NAME.ACTIVITY,
                params: {
                    activityId: store.getters['activity/activityId'],
                },
            });
        },
    },
    {
        path: '/team/detail/members/:activityId/:teamId?',
        name: ROUTE_NAME.TEAM_DETAIL_MEMBERS,
        meta: {
            title: '战队成员',
            scrollBehavior: 'restore',
            scorllDefaultPosition: 0,
        },
        component: () => ({
            component: import(/* webpackChunkName: "team" */ '@/pages/team/detail/members.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/team/identification/:activityId',
        name: ROUTE_NAME.TEAM_IDENTIFICATION,
        meta: {
            title: '队旗申请',
            scrollBehavior: 'top',
            scorllDefaultPosition: 0,
            disableShare: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "team" */ '@/pages/team/identification.vue'),
            loading: Loading,
        }),
    },
];
